import { getHasUnpublishedChanges, getIsPublished } from '@app/logic/pages';
import { cn } from '@app/utils/cn';
import { Cms } from '@typings';
import { useTranslation } from 'react-i18next';

interface Props {
  status: Cms.PageStatus | 'preview';
}

export const PageStatus = ({ status }: Props) => {
  const isPublished = getIsPublished(status);
  const withChanges = getHasUnpublishedChanges(status);
  const isPreview = status === 'preview';
  const { t } = useTranslation(['cms', 'common']);

  const pageStatusLabel = {
    preview: t('common:preview'),
    published: t('cms:published'),
    published_with_changes: t('cms:unpublished_changes'),
    unpublished: t('cms:unpublished'),
    unpublished_changes: t('cms:unpublished_changes'),
  };

  return (
    <span
      className={cn('body-6', {
        'text-info-62': isPublished || isPreview,
        'text-neutral-40': withChanges,
      })}
    >
      {pageStatusLabel[status]}
    </span>
  );
};
